module.exports = __webpack_public_path__ + "images/psp/FeaturedContentImages/vehicle3.webp";